import { Guest } from '../ts/Guest';

export default function calculateTotalGuests(guests: Guest[]): number {
  return guests.reduce((a, b) => +a + +b.totalArrival, 0);
}
